import { gql } from '@apollo/client';
import { ReferralListInfoShared } from '../fragments';

export default gql`
  query referrals(
    $accountId: ID
    $createdAtStart: String
    $createdAtEnd: String
    $partnerLocationId: ID
    $partnerOrganizationId: ID
    $scanReady: Boolean
    $sentAtStart: String
    $sentAtEnd: String
    $source: [String!]
    $state: [String!]
    $withoutOrders: Boolean
    $limit: Int
    $offset: Int
  ) {
    referrals(
      accountId: $accountId
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      partnerLocationId: $partnerLocationId
      partnerOrganizationId: $partnerOrganizationId
      scanReady: $scanReady
      sentAtStart: $sentAtStart
      sentAtEnd: $sentAtEnd
      source: $source
      state: $state
      withoutOrders: $withoutOrders
      limit: $limit
      offset: $offset
    ) {
      ...ReferralListInfoShared
    }
  }
  ${ReferralListInfoShared}
`;
